import { InjectionKey } from '@vue/composition-api'
import { AxiosInstance } from 'axios'

export class AnalysisApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  GetAnalysis(analysisId: unknown) {
    return this.client
      .get(this.path(`/analysis/${analysisId}`))
      .then(response => {
        return response?.data || {}
      })
  }

  GetAnalysisFragment(analysisId: unknown, fragmentType: unknown) {
    return this.client
      .get(this.path(`/analysis/${analysisId}/fragment/${fragmentType}`))
      .then(response => {
        return response?.data || {}
      })
  }

  SaveAnalysisFragment(
    analysisId: unknown,
    fragmentType: unknown,
    analysisFragment: unknown
  ) {
    return this.client
      .put(
        this.path(`/analysis/${analysisId}/fragment/${fragmentType}`),
        analysisFragment
      )
      .then(response => {
        return response?.data || {}
      })
  }

  ListAnalysis() {
    return this.client.get(this.path(`/analysis`)).then(response => {
      return response?.data || []
    })
  }

  ListAnalysisForUser(clientId: string, userId: string) {
    return this.client
      .get(this.path(`/client/${clientId}/user/${userId}/analysis`))
      .then(response => {
        return response?.data || []
      })
  }
}

export const AnalysisApiKey: InjectionKey<AnalysisApi> = Symbol()
